import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, Check, ArrowRight } from "lucide-react";
import PayslipEstimator from "@/components/PayslipEstimator";

const ICON_BTN = "flex h-12 w-12 items-center justify-center rounded-full text-white shadow-md transition-transform duration-200 hover:scale-105";

export default function Hero() {
    return (
        <section className="dots-bg border-b border-border" data-testid="hero-section">
            <div className="mx-auto grid max-w-7xl items-start gap-12 px-5 py-14 md:px-8 md:py-20 lg:grid-cols-2">
                <div>
                    <p className="text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground" data-testid="hero-tagline">
                        Contractor payroll made simple since 2008
                    </p>
                    <h1 className="mt-4 font-display text-4xl font-bold leading-tight text-primary sm:text-5xl lg:text-[48px] lg:leading-[60px]" data-testid="hero-title">
                        Everything covered. One simple 1.25% fee.
                    </h1>
                    <p className="mt-6 text-lg text-foreground/80">
                        A single 1.25% fee covers payroll, PAYG tax and super, workers’ compensation, professional indemnity and public liability insurance.
                    </p>
                    <p className="mt-4 text-lg text-foreground/80">
                        For the same fee you have the added benefits of salary sacrifice and fee-free novated leasing via Alliance Leasing. BankIT® adds flexibile cash flow between contracts and for holidays
                    </p>
                    <h2 className="mt-8 font-display text-2xl font-bold text-primary sm:text-3xl" data-testid="hero-quote-heading">
                        For your exact take-home pay, ask us for a tailored quote
                        <span className="ml-2 inline-flex h-7 w-7 translate-y-[-2px] items-center justify-center rounded-full bg-emerald-100 align-middle text-emerald-600" aria-hidden="true"><Check size={16} strokeWidth={3} /></span>
                    </h2>
                    <div className="mt-5 flex gap-3">
                        <a href="https://m.me/PayMeAustralia" target="_blank" rel="noopener noreferrer" aria-label="Message PayMe on Messenger" className={`${ICON_BTN} bg-[#0084FF]`} data-testid="hero-messenger-btn"><MessageCircle size={20} /></a>
                        <a href="tel:1800082006" aria-label="Call PayMe on 1800 082 006" className={`${ICON_BTN} bg-emerald-500`} data-testid="hero-call-btn"><Phone size={20} /></a>
                        <a href="mailto:enquiries@payme.com.au" aria-label="Email PayMe at enquiries@payme.com.au" className={`${ICON_BTN} bg-primary`} data-testid="hero-email-btn"><Mail size={20} /></a>
                    </div>
                </div>
                <div>
                    <PayslipEstimator />
                    <div className="mt-5 flex justify-center">
                        <Link
                            to="/superannuation"
                            data-testid="hero-super-link"
                            className="inline-flex items-center gap-2 rounded-lg bg-emerald-500 px-6 py-3 text-base font-semibold text-white shadow-md transition-colors duration-200 hover:bg-emerald-600"
                        >
                            How your super is calculated? <ArrowRight size={16} />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
